import { string, object } from 'yup';

export const ResolutionReasonValidationSchema = object().shape({
  resolutionReason: string().required('Please select a resolution reason'),
  resolutionComment: string().when('commentRequired', {
    is: true,
    then: () => string().required('Please explain the resolution reason'),
  }),
});
